<template>
  <LoadingSpinner />
</template>

<script>
import LoadingSpinner from '@/components/common/LoadingSpinner'

export default {
  name: 'Home',
  components: { LoadingSpinner },
  data() {
    return {
      showsAppBar: false
    }
  },
  mounted() {
    this.showsAppBar = this.$store.state.showAppBar
    this.$store.commit('updateShowAppBar', false)
  },
  destroyed() {
    if (this.$store.state.inApp === false && this.$store.state.inIframe === false) {
      this.$store.commit('updateShowAppBar', false)
      return
    }
    this.$store.commit('updateShowAppBar', this.showsAppBar)
  }
}
</script>
